import { t } from "@lingui/macro";
import React from "react";
import { default as colors } from "../../utils/colors.json";
import { formatCarbsValue, formatNutritionalValue } from "../../utils/nutrition";

function useTranslations() {
  return {
    total: t({
      id: "NutritionBadge.total",
      message: "Total:",
    }),
  };
}

const NutritionBadge = ({
  value,
  percentage,
  label,
  type,
  strictness,
  isHighProtein,
  totalCarbs,
}: {
  value: number;
  percentage: number;
  label: string;
  type?: string;
  strictness?: string;
  isHighProtein?: boolean;
  totalCarbs?: number;
}) => {
  const fmtValue = formatCarbsValue(value);
  const fmtPercentage = formatNutritionalValue(percentage);
  const color = getBadgeColor(type, isHighProtein, strictness);
  const tt = useTranslations();
  const roundedTotalCarbs = totalCarbs && Math.round(totalCarbs);

  return (
    <div className="flex flex-col mx-4" style={{ maxWidth: "80px" }}>
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mx-auto "
      >
        <g>
          <circle cx="32" cy="32" r="32" fill="#d3d3d3" />
          <circle
            style={{
              borderRadius: "50%",
              stroke: "grey",
              strokeWidth: "32px",
              strokeDasharray: `${percentage} 100`,
              transformOrigin: "50% 50%",
              transform: "rotate(-90deg)",
            }}
            r="25%"
            cx="50%"
            cy="50%"
          />
        </g>
        <circle cx="32" cy="32" r="26" data-testid={type} fill={color} stroke="white" strokeWidth="2" />
        <text
          x="50%"
          y="40%"
          alignmentBaseline="middle"
          textAnchor="middle"
          fontFamily="Arial"
          fontSize="16"
          fill={color === colors.WHITE ? "black" : "white"}
          fontWeight="600"
        >
          {fmtValue} g
        </text>
        <text
          x="50%"
          y="70%"
          alignmentBaseline="middle"
          textAnchor="middle"
          fontFamily="Arial"
          fontSize="11"
          fill={color === colors.WHITE ? "black" : "white"}
          fontWeight="600"
        >
          {fmtPercentage} %
        </text>
      </svg>
      <span className="text-xs font-medium pt-2 text-center">{label}</span>

      {type === "carbs" && (
        <span className="text-xs text-center text-light-blue">{`${tt.total} ${roundedTotalCarbs}g`}</span>
      )}
    </div>
  );
};

export default NutritionBadge;

const getBadgeColor = (type?: string, isHighProtein?: boolean, strictness?: string) => {
  if (type === "protein") {
    if (isHighProtein === true) {
      return colors.BLUE_LIGHT;
    } else {
      return colors.WHITE;
    }
  } else if (type === "carbs") {
    if (strictness === "strict" || strictness === "keto") {
      return colors.KETO;
    } else if (strictness === "moderate") {
      return colors.MODERATE;
    } else if (strictness === "liberal") {
      return colors.LIBERAL;
    } else {
      return colors.WHITE;
    }
  } else {
    return colors.WHITE;
  }
};
